/**
 * Deterministic color assignment for a participant.
 * Same participantId → same color across all phones / tablet sessions.
 */
const PALETTE = [
  { name: "terracotta", bg: "#c8553d", fg: "#ffffff" },
  { name: "moutarde", bg: "#e8b04b", fg: "#1a1a1a" },
  { name: "vert-bouteille", bg: "#4a7c59", fg: "#ffffff" },
  { name: "rose-poudre", bg: "#e8a194", fg: "#1a1a1a" },
  { name: "ocre", bg: "#b8854a", fg: "#ffffff" },
  { name: "prune", bg: "#7c4a59", fg: "#ffffff" },
  { name: "vert-sauge", bg: "#a3b18a", fg: "#1a1a1a" },
  { name: "brique", bg: "#8a3825", fg: "#ffffff" },
] as const;

export type ParticipantColor = (typeof PALETTE)[number];

const hash = (s: string): number => {
  let h = 0;
  for (let i = 0; i < s.length; i++) {
    h = (h * 31 + s.charCodeAt(i)) | 0;
  }
  return Math.abs(h);
};

export const getParticipantColor = (participantId: string): ParticipantColor =>
  PALETTE[hash(participantId) % PALETTE.length];

export const getParticipantInitial = (participantId: string, displayName?: string): string => {
  if (displayName?.trim()) return displayName.trim()[0]!.toUpperCase();
  // Last character of UUID is reasonably distributed
  return participantId.slice(-1).toUpperCase();
};
